import Routes from 'constants/Routes';
import useAuthenticationState from 'contexts/authentication/useAuthentication';
import { FC, PropsWithChildren, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useMe from 'contexts/authentication/useMe';
import { AccessRule, isAuthorized, isStartklarOnly } from 'constants/Roles';
import TransparentSpinner from 'components/spinners/TransparentSpinner';

const RequireAuth: FC<
  PropsWithChildren<{
    policy?: AccessRule;
  }>
> = ({ policy: policies, children }) => {
  const {
    state: { isAuthenticated },
  } = useAuthenticationState();
  const me = useMe();
  const location = useLocation();

  const isAuthorizedByRolePolices = useMemo(() => {
    if (policies) {
      return isAuthorized(policies.allow, policies.deny, me?.roles);
    }
    return true;
  }, [me?.roles, policies]);

  if (!isAuthenticated)
    // inte inloggad
    return (
      <Navigate replace state={{ from: location }} to={Routes.account.login} />
    );

  if (!me) return <TransparentSpinner />; // användaren laddas

  // Användare med enbart StartklarVisare-rollen är låsta till startklar-skärmen
  // och skickas dit oavsett vilken skyddad route de försöker nå (även de som
  // saknar egen policy, t.ex. uppdragslistorna).
  if (isStartklarOnly(me.roles) && location.pathname !== Routes.startklar.index)
    return <Navigate replace to={Routes.startklar.index} />;

  // Gå till 404 om användaren inte har rättigheter
  if (policies && !isAuthorizedByRolePolices)
    return <Navigate to={Routes.notFound} />;

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default RequireAuth;
